import { ClipboardList, GitCompareArrows, ListChecks } from "lucide-react";
import { useEffect } from "react";

import NoteReviewOutput from "@/components/NoteReviewOutput";
import usePostRoundReview from "@/hooks/usePostRoundReview";

export default function ProAnalysisPanel({ teams, notes, isPro, isRoundEnded, roundVersion }) {
  const { clearReviews, finalFocusItems, flowItems, loading, openReview } = usePostRoundReview({
    isPro,
    notes,
    teams,
  });
  const canUseAnalysis = isPro && isRoundEnded;

  useEffect(() => {
    clearReviews();
  }, [clearReviews, roundVersion]);

  return (
    <section className="pro-analysis" data-testid="pro-analysis-section">
      <p className="pro-only-section-label" data-testid="analysis-pro-label">
        For Pro users
      </p>
      <div className="section-heading">
        <div>
          <p className="eyebrow">Post-round analysis</p>
          <h2>Post-round reviews</h2>
        </div>
      </div>
      <div className="analysis-actions">
        {canUseAnalysis && (
          <>
            <button
              onClick={() => openReview("clash-tracker", "flow")}
              disabled={Boolean(loading)}
              data-testid="run-clash-tracker-button"
            >
              <GitCompareArrows size={17} />
              {loading === "flow" ? "Opening…" : "Open Flow Tracker"}
            </button>
            <button
              onClick={() => openReview("final-focus-check", "final-focus")}
              disabled={Boolean(loading)}
              data-testid="run-final-focus-check-button"
            >
              <ListChecks size={17} />
              {loading === "final-focus" ? "Opening…" : "Open Summary & Final Focus Review"}
            </button>
          </>
        )}
      </div>
      {canUseAnalysis ? (
        <p className="note-review-disclosure" data-testid="analysis-review-disclosure">
          Displays only your entered notes, organized by speech stage and side.
        </p>
      ) : isRoundEnded ? (
        <p className="post-round-locked" data-testid="analysis-pro-required-message">
          Post-round reviews are available with Pro.
        </p>
      ) : (
        <p className="post-round-locked" data-testid="analysis-locked-message">
          Available after you end the round.
        </p>
      )}
      <NoteReviewOutput
        emptyMessage="No entered notes were available for this review."
        icon={<GitCompareArrows size={16} />}
        items={flowItems}
        testId="flow-tracker-output"
        title="Flow Tracker"
      />
      <NoteReviewOutput
        emptyMessage="No Summary or Final Focus notes were available for this review."
        icon={<ClipboardList size={16} />}
        items={finalFocusItems}
        testId="summary-final-focus-review-output"
        title="Summary & Final Focus Review"
      />
    </section>
  );
}
